import api from 'utils/apiClient';

export const loadPackages = (params) => {
  return api.get(`/packages`, {
    params,
  })
}

export const createPackage = (data) => {
  return api.post('/packages', data)
}

export const editPackage = ({id, ...data}) => {
  return api.patch(`/packages/${id}`, data, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    },
  })
}

export const deletePackage = (id) => {
  return api.delete(`/packages/${id}`)
}

export const loadCoinPackages = (params) => {
  return api.get('/coin_packets', {
    params,
  });
};

export const createCoinPackage = (data) => {
  return api.post('/coin_packets', data)
}

export const editCoinPackage = ({id, ...data}) => {
  return api.patch(`/coin_packets/${id}`, data, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    },
  })
}

export const deleteCoinPackage = (id) => {
  return api.delete(`/coin_packets/${id}`)
}